import React, { useEffect, useState } from 'react';
// components
import ItemButtonListItem from './ItemButtonListItem';

const ItemButtonList = ({ el, index, changeBtnList, fixedRatio }) => {
    //state
    const [buttonsMaxLength, setButtonsMaxLength] = useState(3);

    // 카드 이미지형에 따라 버튼 갯수 바꿈
    useEffect(() => {
        if (fixedRatio) {
            setButtonsMaxLength(2);
        } else {
            setButtonsMaxLength(3);
        }
    }, [fixedRatio]);

    // 버튼 리스트
    let buttonsList = el.buttons ? [...el.buttons] : [];

    // 버튼 추가
    const onClickAddButton = (e) => {
        if (buttonsList.length < buttonsMaxLength) {
            const newData = {
                label: '버튼 설정',
                action: 'webLink',
                webLinkUrl: '',
            };
            // 휴
            if (!el.buttons) {
                buttonsList = [newData];
            } else {
                buttonsList.push(newData);
                // 카드 정사각형 이미지일 경우 버튼명 8자
                if (fixedRatio) {
                    buttonsList.forEach((btn) => {
                        btn.label = btn.label.substr(0, 8);
                    });
                }
            }
            // 버튼 리스트 보냄
            changeBtnList(buttonsList, index);
        }
    };

    // 버튼 변경, 모달에서 콜백
    const changeBtn = (buttonObj, buttonIdx) => {
        buttonsList[buttonIdx] = buttonObj;
        // 버튼 리스트 보냄
        changeBtnList(buttonsList, index);
    };

    // 버튼 삭제
    const delBtn = (buttonIdx) => {
        //delete buttonsList[buttonIdx]; 이건 왜 지우고나면 빈값으로 남아있는거..??
        buttonsList = buttonsList.filter(
            (num) => num !== buttonsList[buttonIdx]
        );
        // 버튼 리스트 보냄
        changeBtnList(buttonsList, index);
    };

    return (
        <>
            <ul className="item-button-list">
                {el.buttons &&
                    el.buttons.map((button, i) => (
                        <ItemButtonListItem
                            key={i}
                            button={button}
                            buttonIdx={i}
                            changeBtn={changeBtn}
                            delBtn={delBtn}
                            fixedRatio={fixedRatio}
                            buttonsLength={el.buttons.length}
                        />
                    ))}
            </ul>
            {buttonsList && buttonsList.length < buttonsMaxLength && (
                <button className="btn-list-add-btn" onClick={onClickAddButton}>
                    + 버튼 추가
                </button>
            )}
        </>
    );
};

export default ItemButtonList;
